module.exports = __webpack_public_path__ + "static/media/galerija_2022_0024.6ac81e9c.jpg";